import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf", fontWeight: "normal" },
    { src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf", fontWeight: "bold" }
  ]
});

const eyeIcon = "./eye.png"

// Define styles for the PDF document
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
  },
  section: {
    marginBottom: 15,
  },
  title: {
    fontSize: 12, // Decreased font size
    fontFamily: "Open Sans", // Must match registered name
    fontWeight: "bold", // Ensures the bold variant is used
    backgroundColor: "#0E2841",
    color: "white",
    padding: 6,
    borderRadius: 5,
    marginBottom: 10,
  },
  header: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#0E2841",
  },
 
  documentItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  icon: {
    width: 15,
    height: 15,
    marginRight: 10,
  },
  documentName: {
    fontFamily: "Open Sans", // Must match registered name
    fontWeight: "bold", // Ensures the bold variant is used
    fontSize: 8,
    color: "#000000",
  },
  note: {
    fontSize: 12, // Decreased font size
    fontFamily: "Open Sans", // Must match registered name
    fontWeight: "bold", // Ensures the bold variant is used
    marginTop: 20,
    color: "#000000",
  },
  link: {
    color: "#0000EE",
    textDecoration: "underline",
  },
  columnsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  column: {
    width: "48%", // Adjust width to leave some space between columns
  },
});

// Define the PDF component
const SchemeDocumentTemplate = ({ documents=[], selectedSchemeOptions }) => {
  // Calculate the midpoint to split documents into left and right columns
  const mid =Array.isArray(documents) && documents?.length>0 ? Math.ceil(documents.length / 2) : 1;
  const leftDocuments = documents.slice(0, mid); // First half
  const rightDocuments = documents.slice(mid); // Second half

  return (
    <View>

 <View style={styles.section}>

        <Text style={styles.title}>Scheme Documents</Text>
 </View>

        {/* Render the list of documents in two columns */}
        {documents && documents.length > 0 ? (
          <View style={styles.columnsContainer}>
            {/* Left Column */}
            <View style={styles.column}>
              {leftDocuments.map((doc, index) => (
                <View key={index} style={styles.documentItem}>
                  <Image
                   src={eyeIcon}
                    style={styles.icon}
                  />
                  <Text style={styles.documentName}>{doc.name}</Text>
                </View>
              ))}
            </View>

            {/* Right Column */}
            <View style={styles.column}>
              {rightDocuments.map((doc, index) => (
                <View key={index} style={styles.documentItem}>
                  <Image
                    src={eyeIcon}
                    style={styles.icon}
                  />
                  <Text style={styles.documentName}>{doc.name}</Text>
                </View>
              ))}
            </View>
          </View>
        ) : (
          <Text style={styles.documentName}>
            No Documents are there for {selectedSchemeOptions[0]}
          </Text>
        )}

        {/* Render the footer note */}
        
          <Text style={styles.note}>
            Note: Please reach out to us on{" "}
            <Text style={styles.link}>vasuki.compliance@vasukiindia.com</Text> for
            more details.
          </Text>
        
  
    </View>
  );
};

export default SchemeDocumentTemplate;
